import { getBankAccountsData } from "@/Api/bankAccounts";
import {
  BankAccountsFiltersComponent,
  BankAccountsFilters,
} from "@/App/BankAccounts/Filters";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { ApiDataProps } from "@/pages/Tenants";
import { useEffect, useState } from "react";
import { TypePageActions } from "../Plans";
import { TableData } from "@/App/BankAccounts/Table";
import { AddBtn } from "@/App/BankAccounts/Add";
import { usePermissions } from "@/hooks/usePermissions";
import { If } from "@/components/If";
import { Landmark } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";

export type TableDataProps = {
  id: number;
  uuid: string;
  name: string;
  surname: string;
  bank_id: number;
  bank_name: string;
  agency: string;
  account_number: string;
  bank_account_type_id?: number | string;
  is_active: number;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  unity_id?: string;
  unity?: {
    id: string;
    name: string;
  };
};

export const PageList = () => {
  const [listData, setListData] = useState({} as ApiDataProps<TableDataProps>);
  const [state, setState] = useState("loading");
  const { hasPermission } = usePermissions();

  const [currentFilters, setCurrentFilters] = useState<BankAccountsFilters>(
    {}
  );

  const fetchData = async (
    page: number = 1,
    filters: BankAccountsFilters = currentFilters
  ) => {
    setState("loading");
    const { data } = await getBankAccountsData(page, filters);
    setListData(data?.response);
    setState("production");
  };

  useEffect(() => {
    fetchData(1);
  }, []);

  const handleClearFilters = () => {
    setCurrentFilters({});
    fetchData(1, {});
  };

  const pageActions: TypePageActions = {
    next: () => {
      if (listData?.current_page < listData?.last_page) {
        fetchData(listData?.current_page + 1);
      }
    },
    previous: () => {
      if (listData?.current_page > 1) {
        fetchData(listData?.current_page - 1);
      }
    },
    lastPage: () => {
      if (listData?.current_page !== listData?.last_page) {
        fetchData(listData?.last_page);
      }
    },
  };

  return (
    <Main>
      <If condition={hasPermission("view-bank-accounts-list")}>
        <PageHeader
          icon={Landmark}
          title="Contas Bancarias"
          description="Gerencie suas contas bancarias"
        >
          <If condition={hasPermission("create-bank-account")}>
            <AddBtn updateFront={setListData} />
          </If>
        </PageHeader>
        <div className="flex flex-col gap-3">
          <BankAccountsFiltersComponent
            filters={currentFilters}
            onFiltersChange={setCurrentFilters}
            onApplyFilters={() => fetchData(1)}
            onClearFilters={handleClearFilters}
          />
          {state === "loading" ? (
            <CreateLoaderTable cols={5} lines={6} />
          ) : (
            <TableData
              dataApi={listData}
              pageActions={pageActions}
              updateFront={setListData}
            />
          )}
        </div>
      </If>
    </Main>
  );
};
